import { useState } from "react";
import { DrawerForm } from "../../../../components/drawers/DrawerForm";
import DropDown from "../../../../components/form/DropDown";
import TextBox from "../../../../components/form/TextBox";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";
import DataItem from "../../../../models/DataItem";
import { CouponTypes } from "../../../../core/Enums";
import { useHub } from "../../../../core/Global";
import { API_ROUTES } from "../../../../core/Constants";
import { toastSuccess } from "../../../../components/base/Toast";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";


interface IProps {
    onClose?: () => void
    onSave?: () => void
}

export default function CouponGenerateForm(props: IProps) {

    const hub = useHub();

    const [Types] = useState<DataItem[]>([
        {
            id: CouponTypes.DollarDiscount.toString(),
            name: "Dollar Discount"
        },
        {
            id: CouponTypes.FreeSubscription.toString(),
            name: "Free Subscription"
        }
    ])

    const [Months] = useState<DataItem[]>(
        [1, 2, 3, 4, 5, 6].map(m => ({
            id: m.toString(),
            name: m + (m === 1 ? " Month" : " Months")
        }))
    )

    const [couponType, couponTypeSet] = useState<string>(CouponTypes.DollarDiscount.toString())
    const [neverExpires, neverExpiresSet] = useState<boolean>(true)

    const isDollar = couponType === CouponTypes.DollarDiscount.toString()
    const isSubscription = couponType === CouponTypes.FreeSubscription.toString()

    return (
        <DrawerForm id="drawer-coupon-generate"
            title="Generate Coupons"
            size="medium"
            buttonText="Generate"
            focusOn="count"
            onClose={props.onClose}
            onSubmitted={props.onSave}
            onSubmit={(body, callback) => {

                window.hideFormErrors();
                var valid = true;
                var focus = true;

                const count = Number.parseInt(body.count);
                if (!count || count < 1) {
                    window.formError("count", "Please enter a valid number of coupons!", undefined, focus);
                    valid = false;
                    focus = false;
                }

                if (isDollar) {
                    const amount = Number.parseFloat(body.amount);
                    if (!amount || amount <= 0) {
                        window.formError("amount", "Please enter a valid dollar amount!", undefined, focus);
                        valid = false;
                        focus = false;
                    }
                }

                if (!neverExpires && window.isNullOrEmpty(body.expiresAt)) {
                    window.formError("expiresAt", "Please select an expiry date!", undefined, focus);
                    valid = false;
                    focus = false;
                }

                if (!valid) {
                    callback!()
                    return;
                }

                hub.Post(API_ROUTES.Coupons + "generate", body, res => {
                    if (res.success) {
                        toastSuccess(`${res.count ?? count} coupon(s) have been generated successfully!`);
                    }
                    callback!(res)
                })

            }}>

            <div className="mb-10">

                <TextBox id="txt-coupon-count" name="count"
                    label="Number of Coupons" labelUp block numeric maxLength={4} defaultValue="100" />

                <DropDown name="couponType" label="Coupon Type" defaultValue={couponType}
                    labelUp block deselect={false}
                    source={Types}
                    onSelect={val => couponTypeSet(val ?? "")} />

                {
                    isDollar &&
                    <TextBox id="txt-coupon-amount" name="amount"
                        label="Discount Amount ($)" labelUp block numeric icon="dollar-sign" />
                }

                {
                    isSubscription &&
                    <DropDown name="months" label="Free Subscription Months" defaultValue="1"
                        labelUp block deselect={false}
                        source={Months} />
                }

                <div className="mt-6 mb-3">
                    <ToggleSwitch name="neverExpires" label="Never Expires" raw small
                        checked={neverExpires} onChange={e => neverExpiresSet(e)} />
                </div>

                {
                    !neverExpires &&
                    <div className="mb-3">
                        <label className="fs-7 mb-1 d-block">
                            Expiry Date
                            <span id="expiresAt-err" className="small text-danger mx-3 form-error"></span>
                        </label>
                        <input type="date" name="expiresAt"
                            className="form-control form-control-solid form-control-sm" />
                    </div>
                }

                <FlexRow className="mt-4">
                    <Icon icon="info-circle" className="fs-9 text-gray-600 me-1" />
                    <span className="fs-9 text-gray-600">
                        Codes are generated automatically (8 characters, A-Z and digits, never O or 0).
                    </span>
                </FlexRow>

            </div>

        </DrawerForm>
    )
}
